(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    function initCountdown(targetTimestamp) {
    const daysElement = document.getElementById('countdown-days')
    const hoursElement = document.getElementById('countdown-hours')
    const minsElement = document.getElementById('countdown-mins')

    function updateCountdown() {
      const now = new Date().getTime()

      // Parse ISO 8601 date format or Unix timestamp
      let targetTime
      if (
        typeof targetTimestamp === 'string' &&
        targetTimestamp.includes('T')
      ) {
        // ISO 8601 format (e.g., "2025-08-20T08:00:00Z")
        targetTime = new Date(targetTimestamp).getTime()
      } else {
        // Unix timestamp (fallback for backward compatibility)
        targetTime = targetTimestamp * 1000
      }

      const difference = targetTime - now

      if (difference <= 0 || isNaN(targetTime)) {
        // If timestamp is present or past, display 00 for all values
        daysElement.textContent = '00'
        hoursElement.textContent = '00'
        minsElement.textContent = '00'
        return
      }

      // Calculate time remaining
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

      // Update display with zero-padded values
      daysElement.textContent = days.toString().padStart(2, '0')
      hoursElement.textContent = hours.toString().padStart(2, '0')
      minsElement.textContent = minutes.toString().padStart(2, '0')
    }

    // Update immediately
    updateCountdown()

    // Update every minute
    setInterval(updateCountdown, 30000)
  }

  // Get timestamp from data attribute
  const timestampElement = document.querySelector('[data-countdown-timestamp]')
  let targetTimestamp

  if (timestampElement && timestampElement.dataset.countdownTimestamp) {
    targetTimestamp = timestampElement.dataset.countdownTimestamp

    // Try to parse as ISO 8601 first, then as Unix timestamp
    if (targetTimestamp.includes('T')) {
      // ISO 8601 format - use as string
      targetTimestamp = targetTimestamp
    } else {
      // Assume Unix timestamp - convert to number
      targetTimestamp = parseInt(targetTimestamp)
    }
  } else {
    // Default to 7 days from now in ISO format
    const futureDate = new Date()
    futureDate.setDate(futureDate.getDate() + 7)
    targetTimestamp = futureDate.toISOString()
  }

  // Only initialize if we have a valid timestamp
  if (targetTimestamp) {
    initCountdown(targetTimestamp)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-collapsible-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collapsible-text')) {
    customElements.define(
      'collapsible-text',
      class extends HTMLElement {
        constructor() {
          super()

          this.content = this.querySelector('[data-collapsible-content]')
          this.toggle = this.querySelector('[data-collapsible-toggle]')
        }

        connectedCallback() {
          this.toggle?.addEventListener('click', this.handleClick.bind(this))
        }

        handleClick() {
          if (this.content && this.toggle)
            this.content.setAttribute(
              'data-collapsed',
              this.content?.getAttribute('data-collapsed') === 'true'
                ? 'false'
                : 'true'
            )
        }

        disconnectedCallback() {
          this.toggle?.removeEventListener('click', this.handleClick)
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-strikethrough-new-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('strikethroughKlaviyoForm');

    if (!form || form.dataset.bound === 'true') return;

    form.dataset.bound = 'true';

    const formEmail = form.querySelector('input[name="email"]');
    const formButton = form.querySelector('button[type="submit"]');
    const formMessage = form.querySelector('[data-strikethrough-form-message]');
    const klaviyoId = form.querySelector('input[name="klaviyo_id"]')?.value?.trim();
    const listId = form.querySelector('input[name="list_id"]')?.value?.trim();

    let isSubmitting = false;

    const closePopup = () => {
      const popup = document.querySelector('.js-strikethrough-popup');
      const bar = document.querySelector('.js-strikethrough-bar');

      if (popup) popup.classList.remove('active');
      if (bar) bar.classList.add('active');
    };

    const showMessage = (text, status) => {
      if (!(formMessage instanceof HTMLElement)) return;

      formMessage.textContent = text;
      formMessage.dataset.status = status;
      formMessage.hidden = false;
    };

    const hideMessage = () => {
      if (!(formMessage instanceof HTMLElement)) return;

      formMessage.hidden = true;
      formMessage.textContent = '';
      delete formMessage.dataset.status;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (isSubmitting) return;

      const email = formEmail?.value?.trim();

      if (!email) {
        showMessage('Please enter a valid email address.', 'error');
        return;
      }

      if (!klaviyoId || !listId) {
        showMessage('Something went wrong. Please try again.', 'error');
        return;
      }

      isSubmitting = true;
      hideMessage();

      if (formButton instanceof HTMLButtonElement) {
        formButton.disabled = true;
      }

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions?company_id=${klaviyoId}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              revision: '2023-12-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                      },
                    },
                  },
                  custom_source: 'Strikethrough popup',
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId,
                    },
                  },
                },
              },
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Klaviyo subscription failed (${response.status})`);
        }

        showMessage("Thanks! You're signed up.", 'success');

        if (formEmail instanceof HTMLInputElement) {
          formEmail.readOnly = true;
        }

        if (formButton instanceof HTMLButtonElement) {
          formButton.hidden = true;
        }

        window.setTimeout(closePopup, 1500);
      } catch (error) {
        console.error(error);
        showMessage('Something went wrong. Please try again.', 'error');

        if (formButton instanceof HTMLButtonElement) {
          formButton.disabled = false;
        }
      } finally {
        isSubmitting = false;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-responsive"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('responsive-video')) {
    customElements.define(
      'responsive-video',
      class ResponsiveVideo extends HTMLElement {
        constructor() {
          super()

          this.video = this.querySelector('video')
          this.sources = this.querySelectorAll('video source')
          this.playButton = this.querySelector(
            '.snippet-video-responsive-controls-play-button'
          )
          this.soundButton = this.querySelector(
            '.snippet-video-responsive-controls-sound-button'
          )
          this.userPaused = false
        }

        connectedCallback() {
          this.onMediaQueryChange = () => this.updateVideoSource()

          this.mediaQueryLists = [
            ...new Set(
              Array.from(this.sources)
                .map((source) => source.getAttribute('media'))
                .filter(Boolean)
            )
          ].map((media) => window.matchMedia(media))

          this.mediaQueryLists.forEach((mql) => {
            mql.addEventListener('change', this.onMediaQueryChange)
          })

          if (this.video instanceof HTMLVideoElement) {
            this.setupControls()
            this.syncControlState()

            this.onVideoPlay = () => this.syncControlState()
            this.onVideoPause = () => this.syncControlState()
            this.onVideoVolumeChange = () => this.syncControlState()
            this.onVideoLoadedData = () => {
              this.syncControlState()
              this.attemptAutoplay()
            }
            this.onVideoCanPlay = () => {
              this.syncControlState()
              this.attemptAutoplay()
            }

            this.video.addEventListener('play', this.onVideoPlay)
            this.video.addEventListener('pause', this.onVideoPause)
            this.video.addEventListener(
              'volumechange',
              this.onVideoVolumeChange
            )
            this.video.addEventListener('loadeddata', this.onVideoLoadedData)
            this.video.addEventListener('canplay', this.onVideoCanPlay)

            this.attemptAutoplay()
          }
        }

        disconnectedCallback() {
          this.mediaQueryLists?.forEach((mql) => {
            mql.removeEventListener('change', this.onMediaQueryChange)
          })

          if (this.video instanceof HTMLVideoElement) {
            this.video.removeEventListener('play', this.onVideoPlay)
            this.video.removeEventListener('pause', this.onVideoPause)
            this.video.removeEventListener(
              'volumechange',
              this.onVideoVolumeChange
            )
            this.video.removeEventListener('loadeddata', this.onVideoLoadedData)
            this.video.removeEventListener('canplay', this.onVideoCanPlay)
          }

          this.playButton?.removeEventListener('click', this.onPlayButtonClick)
          this.soundButton?.removeEventListener(
            'click',
            this.onSoundButtonClick
          )
        }

        setupControls() {
          if (this.playButton) {
            this.onPlayButtonClick = () => {
              if (
                this.video instanceof HTMLVideoElement &&
                !this.video.paused
              ) {
                this.userPaused = true
              } else {
                this.userPaused = false
              }

              this.togglePlay()
            }
            this.playButton.addEventListener('click', this.onPlayButtonClick)
          }

          if (this.soundButton) {
            this.onSoundButtonClick = () => this.toggleSound()
            this.soundButton.addEventListener('click', this.onSoundButtonClick)
          }
        }

        syncControlState() {
          if (!(this.video instanceof HTMLVideoElement)) {
            return
          }

          if (this.playButton) {
            this.playButton.dataset.playState = this.video.paused
              ? 'play'
              : 'pause'
          }

          if (this.soundButton) {
            this.soundButton.dataset.soundState = this.video.muted
              ? 'off'
              : 'on'
          }
        }

        togglePlay() {
          if (!(this.video instanceof HTMLVideoElement)) {
            return
          }

          if (this.video.paused) {
            const playPromise = this.video.play()

            if (playPromise !== undefined) {
              playPromise.catch(() => this.syncControlState())
            }
          } else {
            this.video.pause()
          }
        }

        toggleSound() {
          if (!(this.video instanceof HTMLVideoElement)) {
            return
          }

          this.video.muted = !this.video.muted
        }

        attemptAutoplay() {
          if (
            !(this.video instanceof HTMLVideoElement) ||
            !this.video.autoplay ||
            this.userPaused ||
            !this.video.paused
          ) {
            return
          }

          this.video.muted = true

          const playPromise = this.video.play()

          if (playPromise !== undefined) {
            playPromise
              .then(() => this.syncControlState())
              .catch(() => this.syncControlState())
          }
        }

        getActiveSource() {
          return Array.from(this.sources).find((source) => {
            const mediaQuery = source.getAttribute('media')
            return !mediaQuery || window.matchMedia(mediaQuery).matches
          })
        }

        getCurrentSourceUrl() {
          if (!(this.video instanceof HTMLVideoElement)) {
            return ''
          }

          return this.video.currentSrc || this.video.src
        }

        updateVideoSource() {
          if (!this.sources) {
            return
          }

          const newSource = this.getActiveSource()

          if (
            !(newSource instanceof HTMLSourceElement) ||
            !(this.video instanceof HTMLVideoElement) ||
            this.getCurrentSourceUrl() === newSource.src
          ) {
            return
          }

          const wasPaused = this.video.paused
          const wasMuted = this.video.muted

          this.video.src = newSource.src
          this.video.load()
          this.video.muted = wasMuted

          if (!wasPaused) {
            const playPromise = this.video.play()

            if (playPromise !== undefined) {
              playPromise.catch(() => this.syncControlState())
            }
          }

          this.syncControlState()
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
